import { createSelector } from '@reduxjs/toolkit';
import { getRangeValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectLiftService = createSelector(selectJsonQuery, jsonQuery => getRangeValue('lift_service')(jsonQuery));
